"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var termsAndConditions = exports.termsAndConditions = "\ntermsAndConditions {\n  header\n  content {\n    header\n    desc {\n      type\n      content {\n        type\n        text\n        bullet\n      }\n    }\n  }\n}\n";